export const environment = {
  production: false,
  apiUrl: 'https://aisummitservice-poc.flowmono.com/api',
  // FastAPI AI service (JusticeFlow analysis pipeline)
  aiApiUrl: 'https://flowmonoaivm.flowmono.com',
  aiApiKey: 'katVJDQNmCkuv8X',
  // Global mock flag for services without a live backend yet.
  // NOTE: AuthService is fully integrated and ignores this flag.
  useMock: true,
};
